import { render, staticRenderFns } from "./m-tab.vue?vue&type=template&id=812108d8"
import script from "./m-tab.vue?vue&type=script&lang=js"
export * from "./m-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports